module.exports = __webpack_public_path__ + "leg.jpg?652116f52a50afa6efe85daae195c4cb";